import { render, staticRenderFns } from "./CardFoodDiary.vue?vue&type=template&id=a5d82d3c&scoped=true"
import script from "./CardFoodDiary.vue?vue&type=script&lang=js"
export * from "./CardFoodDiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d82d3c",
  null
  
)

export default component.exports